import { API_ROUTES } from '../routes'
import { getConnectionUrl } from '../utils'

const triggerDownload = (blob: Blob, id: string) => {
  const downloadUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = downloadUrl
  link.setAttribute('download', `agreement-${id}.pdf`)
  document.body.appendChild(link)
  link.click()
  link.remove()

  window.URL.revokeObjectURL(downloadUrl)
}

const getErrorMessage = (err: unknown) => (err instanceof Error ? err.message : 'Failed to download agreement')

export const useDownloadAgreement = () => {
  return async (id: string) => {
    try {
      const baseUrl = getConnectionUrl(API_ROUTES.AGREEMENT_DOWNLOAD)
      const url = `${baseUrl}?${new URLSearchParams({ id }).toString()}`
      const response = await fetch(url, { credentials: 'include' })

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
      }

      triggerDownload(await response.blob(), id)
    } catch (err) {
      console.error(getErrorMessage(err))
    }
  }
}
